// eslint-disable-next-line no-shadow
export enum HomeFeaturesTab {
	CHARACTERS = 'characters',
	CLOTHS_SWAP = 'cloths-swap',
	PRODUCT_PHOTO = 'product-photo',
}
